// A pool of 100 colors generated from photos on the site.
// Used in a randomized fashion by the loader component.
export const COLORS = [
  "rgb(101, 87, 69)",
  "rgb(128, 99, 45)",
  "rgb(53, 52, 35)",
  "rgb(64, 56, 37)",
  "rgb(125, 121, 116)",
  "rgb(99, 117, 120)",
  "rgb(108, 97, 73)",
  "rgb(63, 56, 41)",
  "rgb(205, 201, 205)",
  "rgb(84, 57, 60)",
  "rgb(86, 71, 56)",
  "rgb(131, 116, 89)",
  "rgb(117, 117, 116)",
  "rgb(97, 108, 119)",
  "rgb(125, 124, 117)",
  "rgb(118, 95, 76)",
  "rgb(105, 115, 114)",
  "rgb(94, 95, 71)",
  "rgb(72, 98, 105)",
  "rgb(73, 90, 91)",
  "rgb(89, 76, 53)",
  "rgb(51, 51, 57)",
  "rgb(110, 95, 73)",
  "rgb(121, 111, 97)",
  "rgb(79, 81, 80)",
  "rgb(132, 140, 145)",
  "rgb(122, 115, 106)",
  "rgb(75, 57, 41)",
  "rgb(30, 35, 32)",
  "rgb(119, 85, 40)",
  "rgb(84, 86, 82)",
  "rgb(79, 70, 63)",
  "rgb(155, 133, 119)",
  "rgb(43, 38, 18)",
  "rgb(44, 41, 35)",
  "rgb(126, 114, 96)",
  "rgb(41, 47, 22)",
  "rgb(4, 21, 55)",
  "rgb(69, 67, 59)",
  "rgb(96, 88, 81)",
  "rgb(62, 57, 56)",
  "rgb(104, 98, 86)",
  "rgb(98, 68, 50)",
  "rgb(52, 50, 50)",
  "rgb(87, 86, 77)",
  "rgb(93, 69, 60)",
  "rgb(105, 96, 90)",
  "rgb(45, 39, 67)",
  "rgb(113, 107, 73)",
  "rgb(42, 40, 37)",
  "rgb(102, 85, 64)",
  "rgb(116, 113, 106)",
  "rgb(83, 89, 83)",
  "rgb(78, 70, 65)",
  "rgb(93, 85, 92)",
  "rgb(76, 69, 50)",
  "rgb(97, 99, 98)",
  "rgb(120, 106, 97)",
  "rgb(95, 101, 82)",
  "rgb(123, 91, 89)",
  "rgb(131, 131, 102)",
  "rgb(23, 25, 25)",
  "rgb(82, 81, 74)",
  "rgb(96, 97, 81)",
  "rgb(83, 58, 56)",
  "rgb(97, 93, 87)",
  "rgb(35, 34, 34)",
  "rgb(107, 85, 46)",
  "rgb(101, 85, 48)",
  "rgb(157, 138, 117)",
  "rgb(86, 85, 83)",
  "rgb(89, 78, 85)",
  "rgb(144, 155, 162)",
  "rgb(108, 100, 90)",
  "rgb(8, 8, 8)",
  "rgb(67, 70, 71)",
  "rgb(114, 84, 49)",
  "rgb(61, 62, 21)",
  "rgb(48, 46, 40)",
  "rgb(89, 65, 53)",
  "rgb(143, 97, 8)",
  "rgb(79, 77, 58)",
  "rgb(59, 60, 57)",
  "rgb(61, 65, 66)",
  "rgb(71, 67, 66)",
  "rgb(52, 56, 49)",
  "rgb(72, 83, 69)",
  "rgb(128, 135, 143)",
  "rgb(94, 82, 76)",
  "rgb(76, 67, 56)",
  "rgb(18, 18, 15)",
  "rgb(128, 129, 130)",
  "rgb(97, 80, 56)",
  "rgb(108, 107, 124)",
  "rgb(57, 56, 57)",
  "rgb(158, 154, 151)",
  "rgb(196, 195, 169)",
  "rgb(116, 98, 95)",
  "rgb(29, 22, 17)",
  "rgb(56, 48, 41)",
] as const;

// Used in a randomized fashion by the error state.
export const ERROR_COLORS = [
  "rgb(89, 65, 53)",
  "rgb(143, 97, 8)",
  "rgb(83, 58, 56)",
  "rgb(84, 57, 60)",
  "rgb(123, 91, 89)",
  "rgb(75, 57, 41)",
  "rgb(255, 0, 0)",
] as const;

// Used in a randomized fashion by the debug state.
export const DEBUG_COLORS = [
  "rgb(0, 255, 255)",
  "rgb(255, 0, 255)",
  "rgb(255, 255, 0)",
  "rgb(0, 0, 255)",
  "rgb(0, 255, 0)",
  "rgb(255, 0, 0)",
] as const;

export const GROUP_SIZE = 20;

export const IS_SMALL_WIDTH = window.innerWidth < 850;
export const IS_XL_WIDTH = window.innerWidth > 2000;
export const IS_NONSTANDARD_WIDTH = IS_SMALL_WIDTH || IS_XL_WIDTH;
export const IS_STANDARD_WIDTH = !IS_NONSTANDARD_WIDTH;

export const WINDOW_OFFSET = IS_SMALL_WIDTH ? 110 : 330;

export const IMAGE_COUNT_BY_WIDTH = Math.floor(window.innerWidth / 90);
